// extracted by mini-css-extract-plugin
module.exports = {"link":"_2L9lEtj2WmW7LZp7B0Yyyp","values":"_3mHdadMwqkgk9yPsEtlMyN"};